import React from 'react';
import { Typography, Divider } from 'antd';
import { useLanguage } from '../store/LanguageContext';
import { contactEmail } from '../utils/site';

const { Title, Paragraph } = Typography;

const PrivacyPage: React.FC = () => {
  const { t } = useLanguage();
  const email = contactEmail();

  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '48px 24px 80px' }}>
      <Title level={2}>{t('privacy.title')}</Title>
      <Divider />

      <Title level={4}>{t('privacy.section1Title')}</Title>
      <Paragraph>{t('privacy.section1Content')}</Paragraph>

      <Title level={4}>{t('privacy.section2Title')}</Title>
      <Paragraph>{t('privacy.section2Content')}</Paragraph>

      <Title level={4}>{t('privacy.section3Title')}</Title>
      <Paragraph>{t('privacy.section3Content')}</Paragraph>

      <Title level={4}>{t('privacy.section4Title')}</Title>
      <Paragraph>{t('privacy.section4Content')}</Paragraph>

      <Title level={4}>{t('privacy.section5Title')}</Title>
      <Paragraph>
        {t('privacy.section5Content')}
        <br />
        <a href={`mailto:${email}`}>{email}</a>
      </Paragraph>

      <Divider />
      <Paragraph type="secondary" style={{ fontSize: 12 }}>
        {t('privacy.effectiveNote')}
      </Paragraph>
    </div>
  );
};

export default PrivacyPage;
